import {useMutation} from "@apollo/client";
import {Modal} from "react-bootstrap";
import {NavLink} from "react-router";

import Button from "@/components/button/Button.tsx";
import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {FormOverlayButtons} from "@/components/form/overlay/FormOverlayButtons.tsx";
import {GQL_CHECKS_QUERY2, GQL_UPDATE_TAGS_STATE} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {BulkSetTagsForm} from "@/pages/checks/list/actions/bulkSetTags/BulkSetTagsForm.tsx";

export interface EditCheckTagsFormValues {
  tags: number[];
}

export interface BulkSetTagsModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkSetTagsModal = ({selectedItemsIds, show, setShow, onSuccess}: BulkSetTagsModalProps) => {
  const [updateChecksTags, {data, loading}] = useMutation<GraphQLResponse<null>>(GQL_UPDATE_TAGS_STATE, {
    refetchQueries: [GQL_CHECKS_QUERY2],
  });

  const handleSubmit = async (data: EditCheckTagsFormValues) => {
    const response = await updateChecksTags({
      variables: {
        ids: selectedItemsIds,
        tags: data.tags,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  const formId = "BulkSetTagsForm";

  const formFooter = (
    <Modal.Footer style={{justifyContent: "space-between"}}>
      <Button as={NavLink} to={"/tags"}>
        Manage Tags
      </Button>
      <div className={"modal-footer p-0"} style={{borderTop: "none"}}>
        <FormOverlayButtons
          form={formId}
          onClick={() => setShow(false)}
          hasCancelButton={true}
          hasSubmitButton={true}
        />
      </div>
    </Modal.Footer>
  );

  return (
    <FormModal
      size="lg"
      disabled={loading}
      formId={formId}
      onCancel={() => setShow(false)}
      show={show}
      title={"Assign tags"}
      footer={formFooter}
      hasRequiredFields
    >
      <BulkSetTagsForm
        formId={formId}
        onSubmit={handleSubmit}
        serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
        onError={console.log}
      />
    </FormModal>
  );
};
